import { useCallback } from 'react';
import { Box, Button, IconButton, useMediaQuery, useTheme } from '@mui/material';

import { ReactComponent as ForwardArrowIcon } from 'common/assets/forward-arrow-icon.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { screenToRoutesMap } from 'features/routes/appRoutes';
import { InternalNavigationScreens } from 'features/entities/entitiesTypes';
import { ReactComponent as JBLogo } from 'common/assets/jb-logo.svg';

export const MigrationToolbar = () => {
  const { t } = useTranslation();
  const isTabletWidth = useMediaQuery('(min-width:481px)');
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const showBackArrow = location.pathname.includes('migrationStart');

  const handleBack = useCallback(() => navigate(-1), [navigate]);

  const handleHelp = useCallback(
    () => navigate(screenToRoutesMap[InternalNavigationScreens.CONTACT_SCREEN]),
    [navigate]
  );

  return (
    <Box
      sx={{
        zIndex: 1,
        width: '100%',
        px: 2,
        display: 'grid',
        gridTemplateColumns: '90px 1fr 90px',
        alignItems: 'center',
        height: 54,
        pt: 0.75,
        '@media (min-width: 481px)': {
          pt: 3.5,
          px: 3,
          height: 76,
        },
      }}
    >
      {showBackArrow && (
        <IconButton
          sx={{ gridColumn: '1/2', color: 'primary.main', width: 48 }}
          size="large"
          onClick={handleBack}
        >
          <ForwardArrowIcon
            style={{
              transform: 'rotate(180deg)',
            }}
          />
        </IconButton>
      )}

      {isTabletWidth && (
        <Box sx={{ gridColumn: '2/3', display: 'flex', justifyContent: 'center' }}>
          <JBLogo style={{ height: 24, color: theme.palette.primary.main }} />
        </Box>
      )}
      <Box sx={{ gridColumn: '3/4', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          sx={{
            textTransform: 'unset',
            fontWeight: 'fontWeightBold',
            textAlign: 'right',
            letterSpacing: 0,
            px: 1.25,
            py: 0.75,
            minWidth: 'unset',
          }}
          onClick={handleHelp}
        >
          {t('migration.menu.help')}
        </Button>
      </Box>
    </Box>
  );
};
